export default "__VITE_ASSET__BqGX32av__"